import { Col, Row } from "react-bootstrap";

const StatCard = ({ label, value }) => (
  <div className="border rounded p-3 h-100">
    <div className="text-muted small mb-1">{label}</div>
    <div className="fs-4 fw-semibold">{value ?? 0}</div>
  </div>
);

const RallyStatsSection = ({ rally }) => {
  return (
    <div className="mb-4">
      <h5 className="mb-3">Stats</h5>
      <Row className="g-3">
        <Col md={4}>
          <StatCard label="Drivers" value={rally?.stats_drivers} />
        </Col>
        <Col md={4}>
          <StatCard label="Events" value={rally?.stats_events} />
        </Col>
        <Col md={4}>
          <StatCard label="Participants" value={rally?.stats_participants} />
        </Col>
      </Row>
    </div>
  );
};

export default RallyStatsSection;
